import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { environment } from '../../environments/environment';
import { User } from './models/user.model';
import { Observable } from 'rxjs/index';



@Injectable()
export class AuthService {

    constructor(private http: HttpClient) {
    }

    isLoggedIn = false;
    redirectUrl: string;   // store the URL so we can redirect after logging in
    private usernameChangedSource = new Subject<string>();   // Observable string sources
    usernameChanged$ = this.usernameChangedSource.asObservable();    // Observable strings

    /**
     * Login to the application
     * @param loginCredentials
     */
    login(loginCredentials): Observable<User> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa(loginCredentials.username.toLowerCase().trim() + ':' + loginCredentials.password)
            })
        };
        return this.http.post<User>(`${environment.apiBaseURL}/auth/login`, {}, httpOptions);
    }

    /**
     * Logout of the application
     */
    logout(): void {
        // remove user from local storage to log the user out
        localStorage.removeItem('mapCloudPortalUser');
        this.usernameChangedSource.next('');
        this.isLoggedIn = false;
    }

    /**
     * Check the login status of the user
     * Can be used on page load to check the local storage
     * @returns {any}
     */
    checkLoginStatus(): User | null {
        let user = JSON.parse(localStorage.getItem('mapCloudPortalUser'));

        if (user) {
            this.isLoggedIn = true;
            return user;
        } else {
            return null;
        }
    }

    /**
     * Set the username that is subscribed to.
     * Updating the Subject from the success handler causes it to go to the error handler so
     * it needs to be set separately
     */
    setUser(user: User): void {
        if (user && user.token) {
            // store user details in local storage to keep user logged in between page refreshes
            localStorage.setItem('mapCloudPortalUser', JSON.stringify(user));
        }
        this.usernameChangedSource.next(user.firstName);
    }

    /**
     * Returns a header with a token to send on to the API
     * @returns {{headers: HttpHeaders}}
     */
    getHeadersWithToken(): HttpHeaders {
        let token = this.getToken();
        let httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        });
        return httpHeaders;
    }

    /**
     * Gets the authentication token
     */
    getToken(): string | null {
        let user = JSON.parse(localStorage.getItem('mapCloudPortalUser'));
        if (user) {
            return user.token;
        }
        return null;
    }


    /**
     * We can't trust localStorage hasn't been tampered with, so ask the server to validate the session token
     * @returns {Observable<User>}
     */
    validateSessionToken(): Observable<User> {
         return this.http.get<User>(`${environment.apiBaseURL}/auth/authenticate-session-token`,
            { headers: this.getHeadersWithToken() });
    }
}
